export default __webpack_public_path__ + "static/media/70.ef5ae13b.jpg";